import React from "react";
import { useSelector } from "react-redux";
import brandColors from "@packages/ui/theme/colors";
import { Box } from "@material-ui/core";
import getBrandFromUrl from "src/utils/getBrandFromUrl";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  breakLine: {
    borderWidth: "1px",
    borderStyle: "solid",
    margin: "0 auto",
    maxWidth: "100%",
    borderColor: (props) => brandColors[props.brand] || brandColors.default,
    marginTop: "50px",
    [theme.breakpoints.down("xs")]: {
      maxWidth: "90%",
    },
    [theme.breakpoints.up("md")]: {
      maxWidth: "650px",
    },
  },
}));

function formatDateToDDMMYYYY(dateStr) {
  if (!dateStr) {
    return "";
  }
  const [year, month, day] = dateStr.split("-");
  return `${day}-${month}-${year}`;
}
const RentalDateChangingComfirm = () => {
  const ra_number = useSelector((state) => state.rental.rentalVehicle?.LastRANumber);
  const locationName = useSelector((state) => state.rental.locationName);
  const updateNewReturnDate = useSelector((state) => state.rental.updateNewReturnDate);
  const brand = getBrandFromUrl().toLowerCase();
  const classes = useStyles({ brand });

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "80vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box sx={{ textAlign: "center", mb: 3, width: "70%" }}>
        <h1 style={{ color: "#000000ff", fontWeight: 700, marginBottom: "20px" }}>
          Success! Your booking change has been processed
        </h1>
        <img src="/static/images/check_mark-trans.png" alt="Success" style={{ width: "200px" }} />
        <h2 style={{ marginBottom: "8px" }}>Your Booking Details</h2>
        <Box
          sx={{
            margin: "0 auto",
            textAlign: "center",
          }}
        >
          <p>
            <strong>Rental Agreement No: </strong>
            {ra_number}
          </p>
          <p>
            <strong>Return Date: </strong>
            {updateNewReturnDate
              ? formatDateToDDMMYYYY(updateNewReturnDate.newReturnDate?.split("T")[0])
              : ""}
          </p>
          <p>
            <strong>Return Time: </strong> {updateNewReturnDate.newReturnDate?.split("T")[1] ?? ""}
          </p>
          <p>
            <strong>Return Location: </strong> {locationName ?? ""}
          </p>
        </Box>

        <hr className={classes.breakLine}></hr>
      </Box>
      <Box sx={{ textAlign: "center", mb: 3, width: "55%", maxWidth: "600px", margin: "0 auto" }}>
        <p>
          At this stage, no payment has been taken. If there’s an outstanding balance for your
          booking modification one of our team members will try to authorise this amount on the
          credit/debit card on file so, please ensure you have additional funds available to cover
          your modification.
        </p>
      </Box>
    </Box>
  );
};

export default RentalDateChangingComfirm;
